// extracted by mini-css-extract-plugin
export var hidden = "_ub-0";